import React from 'react';

function Home() {
  return (
    <div className="p-6 space-y-6">
      <h2 className="text-lg font-semibold text-white-700 mb-4 justify-center flex items-center">
        DEMO:  Online Business management application
      </h2>
      <div className="text-md font-semibold text-orange-500 mb-4 justify-center flex items-center">
        যেকোনো Email এবং Password ব্যবহার করে Log-in করুন। এটি একটি Demo সংস্করণ, তাই Sign-up করার প্রয়োজন নেই।
      </div>

      <details className="text-sm text-white">
        <summary className="cursor-pointer text-blue-400 underline">Read More</summary>
        <div className="mt-2 space-y-2">
          <p className="text-green-100">
            চূড়ান্ত Production সংস্করণে বিভিন্ন Log-in Credentials (যেমন Email, Password ইত্যাদি) দেওয়া হবে। Access control-এর উদাহরণ হলো: Admin, managers, employees, super admin।
            এর ফলে একজন ব্যক্তি সব modules-এ access করতে পারবে না। যেমন, একজন Super Admin সব জায়গায় access করতে পারবে,
            কিন্তু একজন manager কেবল তার নিজের department-এর কাজ দেখতে, এবং Update বা Delete ইত্যাদি করতে পারবে।
          </p>
          <p className="text-white">
            আমরা Agile development (সবচেয়ে আধুনিক ও স্ট্যান্ডার্ড পদ্ধতি) অনুসরণ করছি, তাই ক্লায়েন্টের প্রয়োজন অনুযায়ী আমরা ক্রমাগত Update/customize করতে পারি।
          </p>
        </div>
      </details>

      <div className="p-6 space-y-6">
        <h1 className="text-2xl font-bold text-gray-800">Modules</h1>
        {/* Quick Access to Modules */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-6">
          {[
            { name: 'HR', icon: '👥', path: '/hr-dashboard' },
            { name: 'Accounts', icon: '💰', path: '/accounts' },
            { name: 'Inventory', icon: '📦', path: '/inventory/dashboard' },
            { name: 'POS', icon: '🛒', path: '/pos/dashboard' },
            { name: 'Sales', icon: '💼', path: '/sales/dashboard' },
            { name: 'Settings', icon: '⚙️', path: '/settings' },
          ].map(({ name, icon, path }) => (
            <a
              href={path}
              key={name}
              className="flex flex-col items-center justify-center p-6 lg:p-8 rounded-xl shadow-md bg-white hover:bg-gray-100 transition transform hover:scale-105 text-center"
            >
              <div className="text-4xl lg:text-5xl mb-2">{icon}</div>
              <div className="text-base lg:text-lg font-medium text-gray-700">{name}</div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Home;
